import React from 'react';
import { Typography, Skeleton } from '@vtblife/uikit';

import classname from '@search/classname/src';
import Image from '@search/vtbeco-frontend-core/view/common/components/Image';
import { BanksMortgageOffers } from '../../common/BanksMortgageOffers/BanksMortgageOffers';
import { VTB_ID, MAX_MORTGAGE_DISCOUNT } from '../../common/constants';

import './style.css';

const cn = classname.bind(null, 'MobileMortgageOffers');

export const MobileMortgageOffers = ({ offers, loading, handleClick, scrollToStart }: {
    offers: BanksMortgageOffers;
    loading: boolean;
    handleClick: () => void;
    scrollToStart: () => void;
}) => {
    const wrapRef = React.useRef<HTMLDivElement>(null);
    const [ showAll, setShowAll ] = React.useState(false);
    const [ tableHeight, setTableHeight ] = React.useState(300);

    const handleShowMore = () => {
        setTableHeight(prev => prev + Math.min(500, offers.length * 100 - prev));
    };

    const handleHide = () => {
        setShowAll(false);
        setTableHeight(300);
        scrollToStart();
    };

    React.useEffect(() => {
        if (wrapRef?.current && tableHeight >= wrapRef?.current.scrollHeight) {
            setShowAll(true);
        }
    }, [ tableHeight ]);

    const bankOffers = (<>
        {offers.map((offer, index) => (
            <div key={index} className={cn('offer')} onClick={handleClick}>
                <div className={cn('line')}>
                    <Typography variant='secondary-alone' color='primary' className={cn('title')}>
                        <Image
                            width={24}
                            height={24}
                            loading='lazy'
                            alt={offer?.name ?? ''}
                            url={offer.icon?.origin}
                        />
                        {offer.name}
                    </Typography>
                    {offer.bankId === VTB_ID && (
                        <div className={cn('benefit')}>
                            <Typography variant='small-alone' color='primary-alt-bg'>
                                быстрое рассмотрение
                            </Typography>
                        </div>
                    )}
                </div>
                <div className={cn('line')}>
                    <Typography variant='promo-primary-alone' bold color='primary'>
                        {`от ${offer.minimalPaymentFormatted?.replace('₽', '')} ₽/мес.`}
                    </Typography>
                    {offer.bankId === VTB_ID ? (
                        <div className={cn('percent')}>
                            <Typography variant='primary-alone' color='orange'>
                                {`от ${offer.minimalPercentFormatted}`}
                            </Typography>
                            <Typography variant='secondary-alone' color='secondary' className={cn('oldPercent')}>
                                {`${offer.minimalPercent + MAX_MORTGAGE_DISCOUNT}%`.replace('.', ',')}
                            </Typography>
                        </div>
                    ) : (
                        <Typography variant='primary-alone' color='secondary'>
                            {`от ${offer.minimalPercentFormatted}`}
                        </Typography>
                    )}
                </div>
            </div>
        ))}
    </>);

    const loadingOffers = (<>
        {[ null, null, null ].map((item, index) => (
            <div key={index} className={cn('loading')}>
                <Skeleton size='promo-h4' />
                <Skeleton size='promo-h4' />
            </div>
        ))}
    </>);

    return (<>
        <div
            style={offers.length > 3 ? { maxHeight: `${loading ? 330 : tableHeight}px` } : undefined}
            ref={wrapRef}
            className={cn()}
        >
            {loading ? loadingOffers : bankOffers}
        </div>
        {offers.length > 3 && (
            // eslint-disable-next-line max-len
            <Typography variant='secondary-alone' color='link' onClick={showAll ? handleHide : handleShowMore} bold className={cn('showAll')}>
                {showAll ? 'Скрыть' : `Показать ещё ${Math.min(5, offers.length - tableHeight / 100)}`}
            </Typography>)
        }
    </>);
};
